/* eslint-disable import/extensions */

// Services Img Imports
import Web from '../assets/images/Services/Web.png';
import Mobile from '../assets/images/Services/Mobile.png';
import UIUX from '../assets/images/Services/Design.png';

// Portfolio Img Imports
import KMO_NFT from '../assets/images/Portfolio/KMO_NFT.png';
import HelloMaaS from '../assets/images/Portfolio/HelloMaaS.png';
import Stream from '../assets/images/Portfolio/Stream.png';
// import Freelance from '../assets/images/Portfolio/Freelance.png';
import Aura from '../assets/images/Portfolio/Aura.png';
// import Surtido from '../assets/images/Portfolio/Surtido.png';
// import ManagementApp from '../assets/images/Portfolio/ManagementApp.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import Sasha from '../assets/images/Testimonials/Sasha.jpg';
import Reiner from '../assets/images/Testimonials/Reiner.jpg';
import Kruger from '../assets/images/Testimonials/Kruger.jpg';

// TeamMembers
import RD from '../assets/images/TeamMembers/ritikDhote.jpeg';
import SST from '../assets/images/TeamMembers/sohanThakur.jpeg';
import YPK from '../assets/images/TeamMembers/yashKammo.jpeg';
import VS from '../assets/images/TeamMembers/vishalSharma.jpeg';
import TD from '../assets/images/TeamMembers/tejanshuDongre.jpg';
// import Frontend2 from '../assets/images/TeamMembers/Frontend2.jpg';
import RP from '../assets/images/TeamMembers/rohan.jpeg';

export const Services = [
  {
    title: 'Web Development',
    imageUrl: Web,
    animation: 'left',
  },
  {
    title: 'Mobile Development',
    imageUrl: Mobile,
    animation: 'up',
  },
  {
    title: 'UI/UX Design',
    imageUrl: UIUX,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'NFT Market Plase',
    imageUrl: KMO_NFT,
    type: 'Website',
    responsibility: [
      'Full Stack Development',
      'Blockchain Development',
      'UI/UX Design',
    ],
    projectDesc: "ModernNFTMarketplace is a state-of-the-art NFT marketplace dedicated to the creation, promotion, and sale of exclusive digital art and collectibles. Our platform not only provides creators with the tools to mint and showcase their NFT collections, but also ensures a seamless and visually stunning experience for buyers and collectors. With a strong focus on delivering a high-quality user interface and user experience, ModernNFTMarketplace stands out as a premier destination for both emerging and established digital artists, fostering a vibrant and dynamic community within the NFT space. We are committed to innovation, security, and the empowerment of creators through blockchain technology.",
    credit: 'https://dribbble.com/shots/15164950-Recruiting-app',
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Real Estate Marketplace',
    imageUrl: Stream,
    type: 'Website',
    responsibility: [
      'Full Stack Development',
      'UI/UX Design',
    ],
    projectDesc: 'A comprehensive Full Stack Real Estate Marketplace built with the MERN stack, offering seamless functionality for renting and purchasing houses, farms, apartments, and multi-family properties. The platform leverages modern technologies such as React.js, Redux Toolkit, Tailwind CSS, Framer Motion, and Redux Persist on the front end, while utilizing Node.js, Express.js, MongoDB for the back end. Firebase Storage is integrated for efficient file management, and OAuth is implemented for secure user authentication.',
    credit: 'https://dribbble.com/shots/15276430-Stream',
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'HelloMaaS',
    imageUrl: HelloMaaS,
    type: 'Website',
    responsibility: [
      'Python Full Stack Development',
      "AWS",
      "JavaScript",
      "Docker",
      "Jira",
      'UI/UX Design',
    ],
    projectDesc: "HelloMaaS is a web scraping tool designed to automate the process of extracting data from multiple websites with a single click. The project focuses on simplifying web scraping tasks by providing a user-friendly interface and seamless integration with various websites.  we harnessed these models to extract various data points from contract documents. This involved identifying and extracting crucial information such as legal terms, lessee details, contract dates, locations, addresses, names, types, ranges, and meridians.",
    credit: 'https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept',
  },
  {
    id: 'asd1293ufgdfgs4',
    title: 'Aura',
    imageUrl: Aura,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15176338-Aura-Website-Main-Page',
  },
  // {
  //   id: 'asd1293ulskmnb5',
  //   title: 'Surtido Rico',
  //   imageUrl: Surtido,
  //   type: 'Website',
  //   responsibility: [
  //     'Web Development',
  //     'UI/UX Design',
  //   ],
  //   credit: 'https://dribbble.com/shots/15173118-Surtido-Rico',
  // },
  // {
  //   id: 'asd1293ulkmnbj6',
  //   title: 'Courses Management',
  //   imageUrl: ManagementApp,
  //   type: 'Website',
  //   responsibility: [
  //     'Web Development',
  //     'UI/UX Design',
  //   ],
  //   credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  // },
];

export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We communicate our project ideas and progress to make it clear.',
    imageUrl: Communicative,
  },
  {
    title: 'Management',
    description: 'We manage our project properly to make our project done well.',
    imageUrl: Management,
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team are very collaborative to make our project done well.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We've did so many project and all of our client love it.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Sasha Rose',
    company: 'Owner, Surveyor Corps',
    testimoni: 'Thanks for Racxstudio, you guys are the best! Keep up the great work!',
    imageUrl: Sasha,
  },
  {
    id: 2,
    name: 'Kruger Khan',
    company: 'Director, Shultan Oil',
    testimoni: 'I just wanted to let you know that it’s been great working with Racxstudio.',
    imageUrl: Kruger,
  },
  {
    id: 3,
    name: 'Reiner John',
    company: 'CEO, Marley CO',
    testimoni: 'Racxstudio is so great. Thank you so much for a job well done.',
    imageUrl: Reiner,
  },
];

export const TeamMembers = [
  {
    name: 'Sohan Singh Thakur',
    position: 'Founder',
    techStack: "BDE and Marketing",
    imageUrl: SST,
    
  },
  {
    name: 'Yash Pawar Kamdi',
    position: 'CEO',
    techStack: "Full Stack Developer",
    imageUrl: YPK,
  },
  {
    name: 'Ritik Dhote',
    position: 'CTO',
    techStack: "Python Full Stack",
    imageUrl: RD,
  },
  {
    name: 'Vishal Sharma',
    position: 'COO',
    imageUrl: VS,
    techStack: "Full Stack Developer",
  },
  {
    name: 'Tejanshu Dongre',
    position: 'CHRO',
    imageUrl: TD,
    techStack: "Head of Management",
  },
  {
    name: 'Rohan Patil',
    position: 'Designing Manager',
    imageUrl: RP,
    techStack: "UI/UX and Networking",

  },
];
